import Billing from 'components/global/Billing';

const LenderBilling = () => <Billing />;

export default LenderBilling;
